/**
 * PortaSofa 菜单交互功能 - 最终版
 * 文件名：portasofa-mega-menu.js
 * 位置：assets/portasofa-mega-menu.js
 */

(function() {
    'use strict';

    // 关闭移动菜单
    function closeMobileMenu() {
        const mobileMenu = document.querySelector('.portasofa-mobile-menu-overlay');
        const menuBtn = document.querySelector('.portasofa-mobile-menu-btn');
        const body = document.body;
        
        if (mobileMenu && menuBtn) {
            mobileMenu.classList.remove('active');
            menuBtn.classList.remove('active');
            body.classList.remove('portasofa-menu-open');
        }
    }

    // 切换移动菜单
    function toggleMobileMenu() {
        const mobileMenu = document.querySelector('.portasofa-mobile-menu-overlay');
        const menuBtn = document.querySelector('.portasofa-mobile-menu-btn');
        const body = document.body;
        
        if (!mobileMenu || !menuBtn) return;
        
        const isActive = mobileMenu.classList.contains('active');
        
        if (isActive) {
            closeMobileMenu();
        } else {
            mobileMenu.classList.add('active');
            menuBtn.classList.add('active');
            body.classList.add('portasofa-menu-open');
        }
    }

    // 初始化菜单功能
    function initMegaMenu() {
        // 移动菜单按钮点击事件
        const menuBtn = document.querySelector('.portasofa-mobile-menu-btn');
        if (menuBtn) {
            menuBtn.addEventListener('click', function(e) {
                e.stopPropagation();
                toggleMobileMenu();
            });
        }

        // 点击菜单外部关闭
        document.addEventListener('click', function(event) {
            const mobileMenu = document.querySelector('.portasofa-mobile-menu-overlay');
            const menuBtn = document.querySelector('.portasofa-mobile-menu-btn');
            
            if (!mobileMenu || !menuBtn) return;
            
            if (mobileMenu.classList.contains('active') && 
                !mobileMenu.contains(event.target) && 
                !menuBtn.contains(event.target)) {
                closeMobileMenu();
            }
        });

        // ESC 键关闭菜单
        document.addEventListener('keydown', function(event) {
            if (event.key === 'Escape') {
                closeMobileMenu();
            }
        });

        // 窗口大小改变时关闭移动菜单
        let resizeTimer;
        window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
                if (window.innerWidth > 968) {
                    closeMobileMenu();
                }
            }, 250);
        });

        // 防止菜单内部点击传播
        const mobileMenu = document.querySelector('.portasofa-mobile-menu-overlay');
        if (mobileMenu) {
            mobileMenu.addEventListener('click', function(e) {
                e.stopPropagation();
            });
        }
    }

    // DOM 加载完成后初始化
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initMegaMenu);
    } else {
        initMegaMenu();
    }

    // Shopify 主题编辑器支持
    if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:section:load', initMegaMenu);
    }
})();